import http from '@/utils/http'
import { ElMessage } from 'element-plus'

const initialState = () => ({
  item: {}
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_ITEM (state, item) {
    state.item = { ...item }
  },
  SET_ITEM_PROP (state, { prop, value }) {
    state.item = {
      ...state.item,
      [prop]: value
    }
  }
}

export const getters = {
  item: state => state.item
}

export const actions = {
  fetchTaskSchedule ({ commit, getters, rootGetters }, { id = null, force = false } = {}) {
    if (id) {
      if (!force && id === getters.item.ID) {
        return getters.item
      }

      return http({
        url: `${process.env.VUE_APP_API_URL}job/taskschedule/${rootGetters['auth/token']}/${id}`
      }).then(data => {
        commit('SET_ITEM', data)
        return data
      }).catch(e => {
        ElMessage.error('error loading task schedule')

        throw e
      })
    } else {
      commit('SET_ITEM', {})
    }
  }
}
